import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import axios from 'axios';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';

const Page1 = () => {
  const [chartData, setChartData] = useState({
    labels: ['Total Users', 'Total Alarms', 'Total Guardians', 'Total Organizations'],
    datasets: [
      {
        label: 'Statistics',
        data: [0, 0, 0, 0], 
        backgroundColor: ['#4CAF50', '#FFC107', '#2196F3', '#FF5722'],
        borderColor: ['#388E3C', '#FFA000', '#1976D2', '#E64A19'],
        borderWidth: 1,
      },
    ],
  });

  const currentYear = new Date().getFullYear(); 
  const [selectedYear, setSelectedYear] = useState(currentYear); 
  const [selectedMonth, setSelectedMonth] = useState('January'); 


  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  const [dashboardData, setDashboardData] = useState({
    totalUsers: 0,
    totalAlarms: 0,
    totalGuardians: 0,
    totalOrganizations: 0,
  });

  const fetchDashboardData = async () => {
    const apiUrl = 'https://api.safree.org/api-v2022/superAdmin/auth/v1/dashBoard';

   
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Authentication token is missing!');
      return;
    }

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: token, 
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        setDashboardData(response.data.data);
      } else {
        console.error('Failed to fetch dashboard data:', response.data.message);
      }
    } catch (error) {
      if (error.response) {
        console.error('API Error Response:', error.response);
      } else {
        console.error('API Error:', error.message);
      }
    }
  };

  const fetchFilteredData = async () => {
    const apiUrl = 'https://api.safree.org/api-v2022/superAdmin/auth/v1/monthly/graph';

  
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Authentication token is missing!');
      return;
    }

    const requestData = {
      year: selectedYear, 
      month: selectedMonth.toUpperCase(), 
    };

    try {
      const response = await axios.post(apiUrl, requestData, {
        headers: {
          Authorization: token, 
          'Content-Type': 'application/json', 
        },
      });

      if (response.data.success) {
        const { totalUsers, totalAlarms, totalGuardians, totalOrganizations } = response.data.data;

        // Update chart data
        setChartData({
          ...chartData,
          datasets: [
            {
              ...chartData.datasets[0],
              data: [totalUsers, totalAlarms, totalGuardians, totalOrganizations],
            },
          ],
        });
      } else {
        console.error('Failed to fetch data:', response.data.message);
      }
    } catch (error) {
      if (error.response) {
        console.error('API Error Response:', error.response);
      } else {
        console.error('API Error:', error.message);
      }
    }
  };

  useEffect(() => {
    fetchDashboardData(); 
    fetchFilteredData();
  }, [selectedYear, selectedMonth]);

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-12">
          <h2>
            Welcome back, Super Admin Safree <img src={heloicon} alt="Hello Icon" />
          </h2>
          <p className="sub-heading">Dashboard</p>
        </div>
      </div>
      <div className="cards-container">
        <a href="/admin1/user-Management">
        <div className="cards">
          <h3>Total Users</h3>
          <p>{dashboardData.totalUsers}</p>
        </div>
        </a>
        <a href="/admin1/organisation-Management">
        <div className="cards">
          <h3>Total Organizations</h3>
          <p>{dashboardData.totalOrganizations}</p>
        </div>
        </a>
        <div className="cards">
          <h3>Total Guardians</h3>
          <p>{dashboardData.totalGuardians}</p>
        </div>
        <a href="/admin1/alarmManagement">
        <div className="cards">
          <h3>Total Alarms</h3>
          <p>{dashboardData.totalAlarms}</p>
        </div>
        </a>
      </div>
      <div className="filters">
        <label>
          Year:
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))} 
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </label>
        <label>
          Month:
          <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
            <option value="January">January</option>
            <option value="February">February</option>
            <option value="March">March</option>
            <option value="April">April</option>
            <option value="May">May</option>
            <option value="June">June</option>
            <option value="July">July</option>
            <option value="August">August</option>
            <option value="September">September</option>
            <option value="October">October</option>
            <option value="November">November</option>
            <option value="December">December</option>
          </select>
        </label>
      </div>
      <div className="chart-container" style={{ marginTop: '30px' }}>
        <Bar data={chartData} />
      </div>
    </div>
  );
};

export default Page1;
